import Common from "../pages/common/Common";
import EAM from "../pages/eam/EAM";
import LCG from "../pages/lcg/LCG";
import MMS from "../pages/mms/MMS";
import UAM from "../pages/uam/UAM";
import CPM from "../pages/cpm/CPM";
import LOGIN from "../pages/LoginPage";
// 路由配置数组
export const routeConfigs = [
    {
        path: "/common",
        element: Common,
        name: "资产总览",
        description: "系统资产总览",
    },
    {
        path: "/eam",
        element: EAM,
        name: "固定资产",
        description: "固定资产管理系统",
    },
    {
        path: "/uam",
        element: UAM,
        name: "利旧资产",
        description: "利旧资产管理",
    },
    {
        path: "/mms",
        element: MMS,
        name: "科研物资",
        description: "科研物资管理系统",
    },
    {
        path: "/cpm",
        element: CPM,
        name: "三剂物资",
        description: "三剂加工管理",
    },
    {
        path: "/lcg",
        element: LCG,
        name: "低耗用品",
        description: "低值易耗品管理",
    },
    {
        path: "/login",
        element: LOGIN,
        name: "登录",
        description: "登录页",
    },
];
